<template>
  <div class="dash-root">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-dialog v-model="deleteDialogue" max-width="400" content-class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-icon">
          <v-icon color="#ff4757" size="32">mdi-alert-circle-outline</v-icon>
        </div>
        <h3 class="dialog-title">Delete Notification?</h3>
        <p class="dialog-subtitle">Are you sure you want to delete this notification? This action cannot be undone.</p>
        <div class="dialog-actions">
          <v-btn class="btn-cancel" @click="deleteDialogue = false" depressed>Cancel</v-btn>
          <v-btn class="btn-confirm" @click="deleteNotification()" depressed>Delete</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Page Title -->
    <div class="dash-page-header">
      <div>
        <p class="dash-page-header__eyebrow">Overview</p>
        <h1 class="dash-page-header__title">Notifications</h1>
      </div>
    </div>

    <!-- Notifications List -->
    <div class="notification-list" v-if="orders.length > 0">
      <div
        class="notification-card"
        v-for="(item, i) in orders"
        :key="i"
        @click="markAsRead(item._id)"
      >
        <div class="notification-card__icon-box">
          <v-icon color="#3ea56e">mdi-bell-outline</v-icon>
        </div>
        <div class="notification-card__content">
          <div class="notification-card__header">
            <h3 class="notification-card__title">
              <router-link v-if="item.routetype == 'productUpdate' || (item.routetype == 'newProduct' && item.routeId1)" :to="'/productDetails/' + item.routeId1" style="text-decoration:none; color:inherit;">
                {{ item.title }}
              </router-link>
              <span v-else>{{ item.title }}</span>
            </h3>
            <span class="notification-card__time">{{ formatDate(item.update_date) }}</span>
          </div>
          <p class="notification-card__body">{{ item.body }}</p>
        </div>
        <div class="notification-card__actions">
          <v-btn icon small @click.stop="openDeleteDialog(item._id)">
            <v-icon color="#ff4757" size="20">mdi-delete-outline</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" v-else>
      <div class="empty-state__icon">
        <v-icon size="48" color="#a0aec0">mdi-bell-off-outline</v-icon>
      </div>
      <h3 class="empty-state__title">No Notifications</h3>
      <p class="empty-state__subtitle">You're all caught up! Check back later for updates.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import CancelledOrdersItem from "./cancelledOrdersItem";
export default {
  components: {
    // CancelledOrdersItem,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
      deleteDialogue: false,
      itemToDelete: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/notifications/all/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // data: {
        //   orderStatus: ["Cancelled","Cancelled By Seller"],
        // },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.orders = response.data.data;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openDeleteDialog(id) {
      this.itemToDelete = id;
      this.deleteDialogue = true;
    },
    markAsRead(id) {
      axios({
        method: "POST",
        url: "/notification/markasread/" + id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$root.$emit('notification-deleted');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteNotification() {
      const id = this.itemToDelete;
      if (!id) return;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/notification/remove/" + id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Notification Deleted Successfully";
            this.showSnackBar = true;
            this.deleteDialogue = false;
            this.getData();
            this.$root.$emit('notification-deleted');
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>

<style scoped>
.dash-root {
  font-family: poppinsmedium, Roboto, sans-serif;
  padding: 12px 12px;
}

/* Page Header */
.dash-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}

.dash-page-header__eyebrow {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 4px;
  font-family: poppinsmedium, sans-serif;
}

.dash-page-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  font-family: poppinsbold, sans-serif;
  line-height: 1.2;
}

/* Notification List */
.notification-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notification-card {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 14px;
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
}

.notification-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  border-color: #cbeedb;
}

.notification-card__icon-box {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e8f7ee;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.notification-card__content {
  flex: 1;
  min-width: 0; /* for text truncation if needed */
  text-align: left;
}

.notification-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.notification-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
  font-family: poppinssemibold, sans-serif;
}

.notification-card__title a {
  text-decoration: none;
  color: inherit;
  transition: color 0.2s;
}

.notification-card__title a:hover {
  color: #3ea56e;
}

.notification-card__time {
  font-size: 12px;
  color: #8a93a4;
  white-space: nowrap;
}

.notification-card__body {
  font-size: 13px;
  color: #5a6478;
  margin: 0;
  line-height: 1.5;
}

.notification-card__actions {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  text-align: center;
  margin-top: 20px;
}

.empty-state__icon {
  width: 70px;
  height: 70px;
  background: #f8fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-state__title {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px;
  font-family: poppinssemibold, sans-serif;
}

.empty-state__subtitle {
  font-size: 13px;
  color: #8a93a4;
  margin: 0;
}

/* Dialog Styles */
::v-deep .modern-dialog {
  border-radius: 16px;
}

.dialog-card {
  padding: 24px;
  text-align: center;
  border-radius: 16px;
}

.dialog-icon {
  width: 56px;
  height: 56px;
  background: #fff5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px;
  font-family: poppinssemibold, sans-serif;
}

.dialog-subtitle {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 24px;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-cancel {
  flex: 1;
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  box-shadow: none !important;
}

.btn-confirm {
  flex: 1;
  background: #ff4757 !important;
  color: #ffffff !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.2) !important;
}
</style>
